import type { AxiosInstance } from 'axios';
import type { paths } from '../schema';
import type { RequestOptions } from './types';
import { curry1 } from './utils';

export type BillingCreateSetupIntent =
  paths['/api/billing/payment/stripe/setup-intent']['post']['responses']['200']['content']['application/json'];

export const createSetupIntent = async (
  instance: AxiosInstance,
  options?: RequestOptions
): Promise<BillingCreateSetupIntent> => {
  const res = await instance.post<BillingCreateSetupIntent>(
    '/billing/payment/stripe/setup-intent',
    options
  );

  return res.data;
};

export type BillingPaymentMethods =
  paths['/api/billing/payment/stripe/payment-methods']['get']['responses']['200']['content']['application/json'];

export const getPaymentMethods = async (
  instance: AxiosInstance,
  options?: RequestOptions
): Promise<BillingPaymentMethods> => {
  const res = await instance.get<BillingPaymentMethods>(
    '/billing/payment/stripe/payment-methods',
    options
  );

  return res.data;
};

export type BillingSummary =
  paths['/api/billing/summary-usage']['get']['responses']['200']['content']['application/json'];

export const getSummaryUsage = async (
  instance: AxiosInstance,
  options?: RequestOptions
): Promise<BillingSummary> => {
  const res = await instance.get<BillingSummary>(
    '/billing/summary-usage',
    options
  );

  return res.data;
};

export type BillingLicensePlans =
  paths['/api/billing/license-plans']['get']['responses']['200']['content']['application/json'];

export const getBillingLicensePlans = async (
  instance: AxiosInstance,
  options?: RequestOptions
): Promise<BillingLicensePlans> => {
  const res = await instance.get<BillingLicensePlans>(
    '/billing/license-plans',
    options
  );

  return res.data;
};

export type BillingBusinessLicense =
  paths['/api/billing/business-license']['get']['responses']['200']['content']['application/json'];

export const getBusinessLicense = async (
  instance: AxiosInstance,
  options?: RequestOptions
): Promise<BillingBusinessLicense> => {
  const res = await instance.get<BillingBusinessLicense>(
    '/billing/business-license',
    options
  );

  return res.data;
};

export class BillingService {
  public getSummaryUsage;
  public getBillingLicensePlans;
  public getBusinessLicense;
  public getPaymentMethods;
  public createSetupIntent;

  constructor(private instance: AxiosInstance) {
    this.getSummaryUsage = curry1(getSummaryUsage)(this.instance);
    this.getBillingLicensePlans = curry1(getBillingLicensePlans)(this.instance);
    this.getBusinessLicense = curry1(getBusinessLicense)(this.instance);
    this.getPaymentMethods = curry1(getPaymentMethods)(this.instance);
    this.createSetupIntent = curry1(createSetupIntent)(this.instance);
  }
}
